module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-2-lowlands"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "groningen-the-netherlands-19301949"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("and a pastry cook who could make models of fluyts, with three masts, sails, rigging and all, from sugar. I would sit in a corner, listen to the conversations, and hear that all the men were learning from each other.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("From time to time, I would stay with one or another member of the extended family. One of the uncles had been a judge in Java. At their house, he and his wife sat at the dinner table with their two sons, each person had one side of the table. They drank water from tall glasses and had table napkins every day of the week, not just on Sundays. When a course was finished my aunt rang a table bell. A servant then appeared to clear the plates and serve the next course.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Life with family on the farms was very different. There, I learned how to find eggs under the hedge, and how to pull flax and dig for potatoes. The farm of one of my uncles had a pool but my same-age niece and I were not allowed to swim in it. One day, when my parents and I were visiting, the niece and I pretended to have colds and asked for handkerchiefs. We then sneaked off to the pool, and went in naked to swim. We dried ourselves with the handker- chiefs and did not understand how our parents knew right away that we had been swimming.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The next summer, my younger brother and I stayed at one of the farms. When our uncle was away, we pestered the farmhand to let us sit on one of my uncle’s horses, heavy, dark-brown, warm-blooded Groningen horses of the size of a man. He had promised my little brother that he would be first but he forgot and instead lifted me onto the great beast. This so infuriated my brother that he pulled out his belt and with it hit the back of the horse. It reared and galloped away, with me hanging onto its manes. I had a wild and very frightening ride, down the long, straight clay road that led to the farm. Along the neck of the galloping horse I saw that a man on a bicycle was coming towards the farm. It was my uncle. He jumped off his bike and stood in the middle of the road, swinging his arms round and round as if they were the sails of a windmill on fire. The horse stopped dead in its track. As I fell off, his strong hand caught me as if he plucked a feather from the sky.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("On the farm was a girl from the nearby village who came to help my aunt with her work. She would clean the milk cans until they shone like silver but, no matter how clean they were, she always rinsed them with water before putting milk into them. She was the first girl I found to be pretty. She laughed readily and when I said something stupid, again, she would hug me and press me against her lovely breasts.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("There were other women in my five-years-old life. There was Miss Visser at the pre-school, I found her pretty too. The next year I became friendly, albeit friendly of a wordless kind, with the daughter of acquaintances of my parents. Tineke had red hair and walked in what I thought was a stately way. Night after night, I dreamt that I was walking next to her, holding her hand, in a city – but there was nobody there. Later, when I became interested in art and")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9934806","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0019.vue
// module id = 117
// module chunks = 0